import { Button } from '@renderer/components/ui/button'
import { useQuiz } from '@renderer/lib/useQuiz'
import { useTranslation } from 'react-i18next'
// import { useNavigate } from 'react-router'

const QuizEndPage = () => {
  const { score, reset } = useQuiz()
  const { t } = useTranslation('translation', { keyPrefix: 'quiz.end_page' })
  const { t: tScore } = useTranslation('translation', { keyPrefix: 'quiz' })
  // const navigate = useNavigate()

  const handleClick = () => {
    reset()
    // navigate('/home')
  }

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-0 overflow-hidden text-primary px-4 gap-4 [@media(max-height:1100px)]:gap-2">
      <h1 className="font-bold text-primary text-3xl [@media(max-height:1100px)]:text-xl [@media(min-height:1101px)]:text-4xl">
        {t('title')}
      </h1>
      <p className="text-primary text-xl [@media(max-height:1100px)]:text-base [@media(min-height:1101px)]:text-2xl">
        {tScore('score', { count: score })}
      </p>
      <p className="text-primary text-center text-xl [@media(max-height:1100px)]:text-base [@media(min-height:1101px)]:text-2xl">
        {t('comment')}
      </p>
      <Button
        className="bg-white text-primary border-primary hover:bg-primary hover:text-white border-4 text-xl p-6 [@media(max-height:1100px)]:text-base [@media(max-height:1100px)]:p-3 [@media(min-height:1101px)]:text-2xl [@media(min-height:1101px)]:p-8"
        onClick={handleClick}
      >
        {t('home_btn')}
      </Button>
    </div>
  )
}

export default QuizEndPage